<template>
  <div class="author">
    <div class="author_nav">
      <div class="author_left">
        <div class="zazhi">
          <div class="zaziTop">
            <img
              style="float:left;marginLeft:30px;"
              src="../../../../assets/杂志.png"
              alt=""
            />
            <div>
              <h4>
                <span style="fontSize:24px;marginLeft:10px;">杂志</span
                ><span style="color:#E6454A;heigth:22px;margin:0 10px 0 10px;"
                  >|</span
                ><span style="fontSize:12px;color:#657591;">本刊内容信息</span>
              </h4>
            </div>
          </div>

          <div class="video_title">
            <div
              v-for="(item, index) in title"
              :key="index"
              class="video_txt"
              v-if="index < 4"
              @click="dian(item.zt, item.id)"
            >
              <div class="video_name">
                <div
                  style="width: auto;display: inline-block;padding-bottom: 11px;text-align: center;color: #657591;"
                  :class="item.zt ? 'addtxt' : ''"
                >
                  {{ item.txt }}
                </div>
              </div>
            </div>

            <div class="video_right">
              <!-- <div class="zi" @click="jumpduo">更多></div> -->
            </div>
          </div>

          <div v-if="num == 1" class="author_nav2r" style="margin-right: 4%;">
            <div
              @mouseover="addtop(1, item.id)"
              @mouseout="addtop(2, item.id)"
              v-for="(item, index) in zazhiData"
              @click="zazhiJump(item.id)"
              v-if="index < 4"
              class="authorMain"
            >
              <!-- 菱形 -->
              <div :class="item.zt ? 'add2' : ''" class="express_dian"></div>

              <div class="expressMain">
                <h5 :class="item.zt ? 'add1' : ''">
                  {{ item.channelName ? item.channelName : "暂无数据" }}
                </h5>
                <div>{{ item.title }}</div>
                <span
                  >作者：{{ item.authors ? item.authors : "暂无数据" }}</span
                >
              </div>
            </div>
          </div>

          <div v-if="num == 2" class="author_nav2r" style="margin-right: 4%;  ">
            <div
              class="wangqi"
              v-for="(item, index) in wqData"
              @click="aaaa(item)"
              v-if="index < 4"
            >
              <div style="marginLeft:30px">
                <div style="float:left">{{ item.year }}</div>
                <div class="express_dian"></div>
              </div>

              <div class="wangqiMain">
                <div
                  v-for="(aitem, i) in item.issueLists"
                  @click="dianqi(item.year, aitem.issue)"
                >
                  第{{ aitem.issue }}期
                </div>
              </div>
            </div>
          </div>

          <div v-if="num == 3" class="author_nav2r" style="margin-right: 4%;">
            <div>
              网约稿
            </div>
          </div>
        </div>

        <!-- 资讯 -->
        <div class="zixun" style="marginTop:50px; overflow: hidden;">
          <div class="zixunTop">
            <img
              style="float:left;marginLeft:30px;"
              src="../../../../assets/资讯.png"
              alt=""
            />
            <div>
              <h4>
                <span style="fontSize:24px;marginLeft:10px;">资讯</span
                ><span style="color:#E6454A;heigth:22px;margin:0 10px 0 10px;"
                  >|</span
                ><span style="fontSize:12px;color:#657591;"
                  >杂志相关的业内最新资讯尽在此处</span
                >
              </h4>
            </div>
          </div>

          <div class="video_title">
            <div
              v-for="(item, index) in zxTitle"
              :key="index"
              class="video_txt1"
              v-if="index < 6"
              @click="dian1(item.zt, item.id)"
            >
              <div class="video_name">
                <div
                  style="display: inline-block;padding-bottom: 11px;text-align: center;"
                  :class="item.zt ? 'addtxt' : ''"
                >
                  {{ item.txt }}
                </div>
              </div>
            </div>
            <div class="video_right">
              <div class="zi" @click="jumpduo()">更多></div>
            </div>
          </div>

          <div class="messageMain">
            <div
              @mouseover="addtop2(1, item.contentId)"
              @mouseout="addtop2(2, item.contentId)"
              v-for="(item, index) in zxData"
              @click="down(item.channelId, item.contentId, 30)"
              style="marginTop:15px;marginLeft:30px"
            >
              <div :class="item.zt ? 'add2' : ''" class="express_dian"></div>
              <li :class="item.zt ? 'add1' : ''">{{ item.title }}</li>
            </div>
          </div>
        </div>

        <!-- 会议培训 -->

        <div class="huiyi" style="marginTop:50px">
          <div class="huiyiTop">
            <img
              style="float:left;marginLeft:29px;"
              src="../../../../assets/会议培训.png"
              alt=""
            />
            <div>
              <h4>
                <span style="fontSize:24px;marginLeft:10px;">会议培训</span
                ><span style="color:#E6454A;heigth:22px;margin:0 10px 0 10px;"
                  >|</span
                ><span style="fontSize:12px;color:#657591;"
                  >业内刊内各种会议、随时查看</span
                >
              </h4>
            </div>
          </div>

          <div class="video_title">
            <div
              v-for="(item, index) in hyTitle"
              :key="index"
              class="video_txt1"
              v-if="index < 4"
              @click="dian2(item.zt, item.id)"
            >
              <div class="video_name">
                <div
                  style="display: inline-block;padding-bottom: 11px;text-align: center;"
                  :class="item.zt ? 'addtxt' : ''"
                >
                  {{ item.txt }}
                </div>
              </div>
            </div>
            <div class="video_right">
              <div class="zi" @click="xqduo">更多></div>
            </div>
          </div>

          <div
            v-if="num2 == 1"
            class="messageMain;"
            style="width:100%;height:100%;overflow:hidden;display:flex;flex-wrap:wrap;"
          >
            <div
              style="height:100%;width: 50%;"
              @click="clickHy(item)"
              @mouseover="addtop6(1, item.contentId)"
              @mouseout="addtop6(2, item.contentId)"
              v-if="index < 4"
              v-for="(item, index) in xwData"
            >
              <div style="width:100%;height:100%">
                <img
                  style="float:left;marginTop:20px;width:230px;height:130px;"
                  :src="item.titlePhoto"
                  alt=""
                />
              </div>

              <div style="width:50%;float:left;marginLeft:10px;height:100%;">
                <h4 :class="item.zt ? 'add1' : ''" style="color:#2A2D3E;">
                  {{ item.title }}
                </h4>
                <div
                  class="abstruct"
                  style="color:#657591;fontSize:14px;marginTop:-10px;height:60px;overflow: hidden;marginBottom:10px;"
                >
                  {{ item.abstruct }}
                </div>
                <span style="color:#B1B7C3;">{{ item.addDate }}</span>
              </div>
            </div>
          </div>

          <div
            v-if="num2 == 2"
            class="messageMain;"
            style="width:100%;height:100%;"
          >
            <div
              @mouseover="addtop3(1, item.contentId)"
              @mouseout="addtop3(2, item.contentId)"
              v-for="(item, index) in hyData"
              @click="down(item.channelId, item.contentId, 30)"
              style="marginTop:15px;marginLeft:30px"
            >
              <div :class="item.zt ? 'add2' : ''" class="express_dian"></div>
              <li :class="item.zt ? 'add1' : ''">{{ item.title }}</li>
            </div>
          </div>

          <div
            v-if="num2 == 3 || num2 == 4"
            class="messageMain;"
            style="width:100%;height:100%;"
          >
            <div
              @mouseover="addtop3(1, item.contentId)"
              @mouseout="addtop3(2, item.contentId)"
              v-for="(item, index) in hyData"
              @click="down(item.channelId, item.contentId, 30)"
              style="marginTop:15px;marginLeft:30px"
            >
              <div :class="item.zt ? 'add2' : ''" class="express_dian"></div>
              <li :class="item.zt ? 'add1' : ''">{{ item.title }}</li>
            </div>
          </div>
        </div>

        <!-- 学术圈 -->
        <div class="xuesuquan" style="marginTop:50px;">
          <div class="xueshuTop">
            <img
              style="float:left;marginLeft:30px;"
              src="../../../../assets/学术圈.png"
              alt=""
            />
            <div>
              <h4>
                <span style="fontSize:24px;marginLeft:10px;">学术圈</span
                ><span style="color:#E6454A;heigth:22px;margin:0 10px 0 10px;"
                  >|</span
                ><span style="fontSize:12px;color:#657591;"
                  >传播学术，通话只是是学术生态圈的重要意义</span
                >
              </h4>
            </div>
          </div>

          <div class="video_title">
            <div
              v-for="(item, index) in xsqTitle"
              :key="index"
              class="video_txt1"
              v-if="index < 4"
              @click="dian3(item.zt, item.id)"
            >
              <div class="video_name">
                <div
                  style="display: inline-block;padding-bottom: 11px;text-align: center;"
                  :class="item.zt ? 'addtxt' : ''"
                >
                  {{ item.txt }}
                </div>
              </div>
            </div>

            <div class="video_right">
              <div class="zi" @click="xsqMuch">更多></div>
            </div>
          </div>

          <div class="messageMain">
            <div
              @mouseover="addtop4(1, item.contentId)"
              @mouseout="addtop4(2, item.contentId)"
              @click="down(item.channelId, item.contentId, 30)"
              v-for="(item, index) in xsqData"
              style="marginTop:15px;marginLeft:30px;cursor: pointer;"
            >
              <div :class="item.zt ? 'add2' : ''" class="express_dian"></div>
              <li :class="item.zt ? 'add1' : ''">{{ item.title }}</li>
            </div>
          </div>
        </div>

        <!-- 通知公示 -->
        <div class="xuesuquan" style="marginTop:50px;">
          <div
            class="xueshuTop"
            style="display: flex;
    align-items: center;
    border-bottom:2px solid #dbdbdb;
    "
          >
            <img
              style="float:left;marginLeft:30px;width: 32px;height:32px;"
              src="../../../../assets/tzgg.png"
              alt=""
            />
            <div style="display:flex;justify-content: space-between;flex:1;">
              <h4>
                <span style="fontSize:24px;marginLeft:10px;">通知公示</span>
                <span style="color:#E6454A;heigth:22px;margin:0 10px 0 10px;"
                  >|</span
                ><span style="fontSize:12px;color:#657591;">本刊通知公示</span>
              </h4>
              <div
                class="zi"
                style="font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: #D27A13;
    line-height: 23px;
    margin-right: 9px;
    margin-top: 8px;"
                @click="xsqMuch1"
              >
                更多>
              </div>
            </div>
          </div>

          <div class="messageMain">
            <div
              @mouseover="addtop4(1, item.contentId)"
              @mouseout="addtop4(2, item.contentId)"
              @click="down(item.channelId, item.contentId, 30)"
              v-for="(item, index) in tzggData"
              style="marginTop:15px;marginLeft:30px;cursor: pointer;"
            >
              <div :class="item.zt ? 'add2' : ''" class="express_dian"></div>
              <li :class="item.zt ? 'add1' : ''">{{ item.title }}</li>
            </div>
          </div>
        </div>
      </div>

      <div class="author_right">
        <div class="rightTop">
          <div class="top">
            <img src="../../../../assets/jc1.png" alt="" />
          </div>

          <div class="tup">
            <img src="../../../../assets/qkfm1 2.png" alt="" />
          </div>

          <div class="wenzi">
            <span
              >刊名： 中国循环杂志 <br /><span
                >Chinese Circulation Journal</span
              ></span
            ><br />
            <span>主办： 国家心血管病中心</span><br />
            <span>周期： 月刊（自2013年9月起改为月刊）</span><br />
            <span>创刊时间：1986年</span><br />
            <span>出版地：北京市</span><br />
            <span>语种： 中文</span><br />
            <span>开本： 大16开</span><br />
            <span>ISSN： 1000-3614</span><br />
            <span>CN： 11-2212/R</span><br />
            <span>邮发代号：82-212</span><br />
            <span>单价：30元/本</span><br />
            <p>中国科技论文统计源期刊（中国科技核心期刊）</p>
            <p>
              《中国核心期刊（遴选）数据库》收录
              中国学术期刊综合评价数据库统计源期刊 北京大学中文核心期刊 版权说明
            </p>
            <p>
              本刊文章和图表均有版权，未经本社书面许可，不得在互联网和其他媒体上转载和翻印，违者必究。
            </p>
          </div>
        </div>

        <div class="rigthMid">
          <div>
            <img src="../../../../assets/lj1.png" alt="" />
          </div>
          <!-- style="wdith:100%;height:580px"  -->
          <div style="marginBottom:50px">
            <!-- <iframe width="100%" height="580" allowtransparency="true" class="share_self"  frameborder="1" scrolling="no"
             src='this.Url'>
             </iframe> -->
            暂无数据
            <!-- <iframe src="https://widget.weibo.com/weiboshow/index.php?language=&width=0&height=580&fansRow=2&ptype=1&speed=0&skin=1&isTitle=1&noborder=1&isWeibo=1&isFans=0&uid=1666204871&verifier=8b63330b&dpc=1" width="100%" height="580" frameborder="0" scrolling="none"></iframe> -->
            <!-- <iframe ref="demo" src=""></iframe> -->

            <!-- <iframe src="../../static/index.html" frameborder="0" scrolling="auto"></iframe> -->
            <!-- <iframe  width="100%" height="580" allowtransparency="true" class="share_self"  frameborder="1" scrolling="no" src="static/index.html"></iframe> -->
          </div>
        </div>

        <div class="rightBottom">
          <div>
            <img src="../../../../assets/fw1.png" alt="" />
          </div>

          <div class="lookNum">
            <img src="../../../../assets/ll.png" alt="" />
            <span>您是第{{ Visits2 }}位浏览者</span>
          </div>
        </div>
      </div>

      <div style="width:100%;overflow:hidden;">
        <div style="marginTop:50px" class="hezuoTop">
          <img
            style="float:left;marginLeft:30px;"
            src="../../../../assets/合作.png"
            alt=""
          />
          <div>
            <h4>
              <span style="fontSize:24px;marginLeft:10px;">合作</span
              ><span style="color:#E6454A;heigth:22px;margin:0 10px 0 10px;"
                >|</span
              ><span style="fontSize:12px;color:#657591;"
                >与我们志同道合的合作伙伴</span
              >
            </h4>
          </div>
        </div>

        <div class="video_title">
          <div
            v-for="(item, index) in hzTitle"
            :key="index"
            class="video_txt2"
            v-if="index < 4"
            @click="dian4(item.zt, item.id)"
          >
            <div class="video_name">
              <div
                style="display: inline-block;padding-bottom: 11px;text-align: center;"
                :class="item.zt ? 'addtxt' : ''"
              >
                {{ item.txt }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="num4 == 1" class="hzMain">
          <div class="imgMain">
            <div>
              <img src="../../../../assets/合作1.png" alt="" />
            </div>

            <div>
              <img src="../../../../assets/合作2.png" alt="" />
            </div>

            <div>
              <img src="../../../../assets/合作3.png" alt="" />
            </div>

            <div>
              <img src="../../../../assets/合作4.png" alt="" />
            </div>
            <div>
              <img src="../../../../assets/合作5.png" alt="" />
            </div>
            <div>
              <img src="../../../../assets/合作6.png" alt="" />
            </div>
            <div>
              <img src="../../../../assets/合作7.png" alt="" />
            </div>
            <div>
              <img src="../../../../assets/合作8.png" alt="" />
            </div>
            <div>
              <img src="../../../../assets/合作9.png" alt="" />
            </div>
            <div>
              <img src="../../../../assets/合作10.png" alt="" />
            </div>
            <div>
              <img src="../../../../assets/合作11.png" alt="" />
            </div>
            <div>
              <img src="../../../../assets/合作12.png" alt="" />
            </div>
          </div>
        </div>

        <div v-if="num4 == 2" class="hzMain">
          <div
            class="messageMain"
            @mouseover="addtop5(1, item.contentId)"
            @mouseout="addtop5(2, item.contentId)"
            @click="down(item.channelId, item.contentId, 30)"
            v-for="(item, i) in hzData"
          >
            <div :class="item.zt ? 'add2' : ''" class="express_dian"></div>
            <li style="marginTop:15px" :class="item.zt ? 'add1' : ''">
              {{ item.title }}
            </li>
          </div>
        </div>

        <div v-if="num4 == 3" class="hzMain">
          <div
            class="messageMain"
            @mouseover="addtop5(1, item.contentId)"
            @mouseout="addtop5(2, item.contentId)"
            @click="down(item.channelId, item.contentId, 30)"
            v-for="(item, i) in hzData"
          >
            <div :class="item.zt ? 'add2' : ''" class="express_dian"></div>
            <li style="marginTop:15px" :class="item.zt ? 'add1' : ''">
              {{ item.title }}
            </li>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// requ aaa  '../../../../assets/js/index'
export default {
  components: {},
  data() {
    return {
      Visits2: "",
      num: 1,
      num1: 1, //资讯title
      num2: 1, //会议培训title
      num3: 1,
      // url1:require('../../../../assets/js/index'),
      num4: 1, //合作title
      Url:
        "http://widget.weibo.com/weiboshow/index.php?language=&width=0&height=580&fansRow=2&ptype=1&speed=0&skin=1&isTitle=1&noborder=1&isWeibo=1&isFans=0&uid=1666204871&verifier=8b63330b&dpc=1",

      title: [
        {
          id: 1,
          txt: "当期"
        },
        {
          id: 2,
          txt: "往期"
        },
        {
          id: 3,
          txt: "网约稿"
        }
      ],

      zxTitle: [
        {
          id: 1,
          txt: "本周关注"
        },
        {
          id: 2,
          txt: "编辑推荐"
        },
        {
          id: 3,
          txt: "期刊纵览"
        },
        {
          id: 4,
          txt: "指南共识"
        },
        {
          id: 5,
          txt: "观点纵横"
        },
        {
          id: 6,
          txt: "技术产品"
        }
      ],
      xsqTitle: [
        {
          id: 1,
          txt: "学术会议"
        },
        {
          id: 2,
          txt: "专家指导"
        },
        {
          id: 3,
          txt: "病例分享"
        },
        {
          id: 4,
          txt: "视频课件"
        }
      ],
      hyTitle: [
        {
          id: 1,
          txt: "精品会议"
        },
        {
          id: 2,
          txt: "会议热点"
        },
        {
          id: 3,
          txt: "会议消息"
        }
      ],
      hzTitle: [
        {
          id: 1,
          txt: "合作伙伴"
        },
        {
          id: 2,
          txt: "会议合作"
        },
        {
          id: 3,
          txt: "项目合作"
        }
      ],
      zazhiData: [
        {
          id: 1,
          title: "指南共享",
          message: "国家基层高血压防治管理指南2020版",
          author: "作者：阿萨帝你就按四大四大名你死的呢"
        },
        {
          id: 2,
          title: "一切共享",
          message: "奥术大师大所多",
          author: "作者：阿萨帝你就按四大四大名你死的呢"
        },
        {
          id: 3,
          title: "地图共享",
          message: "国家基层高血压防治管理指南2020版",
          author: "作者：阿萨帝你就按四大四大名你死的呢"
        }
      ],
      xwData: [],
      zxData: [],
      xsqData: [],
      tzggData: [],
      hyData: [],
      hzData: [],
      wqData: [],
      dqData: []
    };
  },
  methods: {
    getUrl() {
      // var url='http://widget.weibo.com/weiboshow/index.php?language=&width=0&height=580&fansRow=2&ptype=1&speed=0&skin=1&isTitle=1&noborder=1&isWeibo=1&isFans=0&uid=1666204871&verifier=8b63330b&dpc=1'
      // var url='https://www.baidu.com/'
      // var url='../../static/index.html'
      return url;
    },
    index() {
      this.GetGuoqiData();
      this.GetCurrentPeriod();
      for (var i = 0; i < this.title.length; i++) {
        if (i == 0) {
          this.title[i].zt = true;
          this.title.push("1");
          this.title.pop("1");
        } else {
          this.title[i].zt = false;
          this.title.push("1");
          this.title.pop("1");
        }
      }

      for (var i = 0; i < this.zxTitle.length; i++) {
        if (i == 0) {
          this.zxTitle[i].zt = true;
          this.zxTitle.push("1");
          this.zxTitle.pop("1");
        } else {
          this.zxTitle[i].zt = false;
          this.zxTitle.push("1");
          this.zxTitle.pop("1");
        }
      }

      for (var i = 0; i < this.hyTitle.length; i++) {
        if (i == 0) {
          this.hyTitle[i].zt = true;
          this.hyTitle.push("1");
          this.hyTitle.pop("1");
        } else {
          this.hyTitle[i].zt = false;
          this.hyTitle.push("1");
          this.hyTitle.pop("1");
        }
      }

      for (var i = 0; i < this.xsqTitle.length; i++) {
        if (i == 0) {
          this.xsqTitle[i].zt = true;
          this.xsqTitle.push("1");
          this.xsqTitle.pop("1");
        } else {
          this.xsqTitle[i].zt = false;
          this.xsqTitle.push("1");
          this.xsqTitle.pop("1");
        }
      }

      for (var i = 0; i < this.hzTitle.length; i++) {
        if (i == 0) {
          this.hzTitle[i].zt = true;
          this.hzTitle.push("1");
          this.hzTitle.pop("1");
        } else {
          this.hzTitle[i].zt = false;
          this.hzTitle.push("1");
          this.hzTitle.pop("1");
        }
      }

      this.GetSiteAccessCount();
      this.GetHomePageBlockInfo(1398); //资讯
      this.GetHomePageBlockInfo(2374); //
      this.GetHomePageBlockInfo(2317); //
      this.GetHomePageBlockInfo(1404); //会议热点

      this.GetHomePageBlockInfo(3323); //会议合作
    },
    zazhiJump(id) {
      console.log("123123");
      var year;
      var issue;
      for (var i = 0; i < this.zazhiData.length; i++) {
        if (this.zazhiData[i].zt) {
          year = this.zazhiData[i].year;
        }
      }
      for (var i = 0; i < this.zazhiData.length; i++) {
        if (this.zazhiData[i].zt) {
          issue = this.zazhiData[i].issue;
        }
      }
      this.$router.push({
        path: "/browse_details",
        query: { year: year, issue: issue, issuecid: id }
      });
    },

    jumpduo() {
      //资讯跳转更多
      if (this.num1 == 1) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: "本周关注" }
        });
      } else if (this.num1 == 2) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: "编辑推荐" }
        });
      } else if (this.num1 == 3) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: "期刊纵览" }
        });
      } else if (this.num1 == 4) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: "指南共识" }
        });
      } else if (this.num1 == 5) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: "观点纵横" }
        });
      } else if (this.num1 == 6) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: "技术产品" }
        });
      }
    },

    //会议热点跳转更多
    xqduo() {
      if (this.num2 == 2) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: "会议热点" }
        });
      } else if (this.num2 == 3) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: "会议消息" }
        });
      } else if (this.num2 == 1) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: "精品会议" }
        });
      }
    },
    dianqi(year, issue) {
      this.$router.push({
        path: "/browse",
        query: { year: year, issue: issue }
      });
    },
    clickHy(item) {
      console.log(item.title, "123123");
      if (item.title.indexOf("2020年中国心脏大会") > -1) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: item.title }
        });
      } else if (item.title.indexOf("2021年中国心脏大会") > -1) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: item.title }
        });
      } else if (item.title.indexOf("2022年中国心脏大会") > -1) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: item.title }
        });
      } else if (item.title == "2019年中国心脏大会\n          ") {
        this.$router.push({
          path: "/download_details",
          query: { titlename: item.title }
        });
      } else if (item.title == "2017年中国心脏大会") {
        this.$router.push({
          path: "/download_details",
          query: { titlename: item.title }
        });
      } else if (item.title == "2018年中国心脏大会") {
        this.$router.push({
          path: "/download_details",
          query: { titlename: item.title }
        });
      } else if (item.title == "\n    2016年中国心脏大会\n") {
        this.$router.push({
          path: "/download_details",
          query: { titlename: item.title }
        });
      } else if (
        item.title == "第十届海峡两岸医药卫生交流协会心血\n          "
      ) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: item.title }
        });
      } else if (
        item.title == "第八届海峡两岸医药卫生交流协会心血管专业委员会年会"
      ) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: item.title }
        });
      } else if (
        item.title == "第九届海峡两岸医药卫生交流协会心血管专业委员会年会"
      ) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: item.title }
        });
      } else if (item.title == "第19届中国南方国际心血管病学术会议") {
        this.$router.push({
          path: "/download_details",
          query: { titlename: item.title }
        });
      } else if (
        item.title ==
        "\n    第七届海峡两岸医药卫生交流协会心血管专业委员会年会\n"
      ) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: item.title }
        });
      }
    },
    xsqMuch1() {
      this.$router.push({
        path: "/download_details",
        query: { titlename: "通知公示" }
      });
    },
    xsqMuch() {
      if (this.num3 == 1) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: "学术会议" }
        });
      } else if (this.num3 == 2) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: "专家指导" }
        });
      } else if (this.num3 == 3) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: "病例分享" }
        });
      } else if (this.num3 == 4) {
        this.$router.push({
          path: "/download_details",
          query: { titlename: "视频课件" }
        });
      }
    },

    //一共有多少人浏览
    GetSiteAccessCount() {
      var that = this;
      that.$httphelper
        .GetSiteAccessCount({
          journalId: 201607080003
        })
        .then(res => {
          if (res.code == 200) {
            that.Visits2 = res.data || "";
            that.$loading.hideLoading();
          } else {
          }
        });
    },

    dian(zt, id) {
      this.num = id;
      if (!zt) {
        for (var i = 0; i < this.title.length; i++) {
          if (id == this.title[i].id) {
            this.title[i].zt = true;
            this.title.push("1");
            this.title.pop("1");
          } else {
            this.title[i].zt = false;
            this.title.push("1");
            this.title.pop("1");
          }
        }
      }
    },

    dian1(zt, id) {
      this.num1 = id;

      if (id == 1) {
        this.GetHomePageBlockInfo(2374);
      } else if (id == 2) {
        this.GetHomePageBlockInfo(1406);
      } else if (id == 3) {
        this.GetHomePageBlockInfo(1407);
      } else if (id == 4) {
        this.GetHomePageBlockInfo(1408);
      } else if (id == 5) {
        this.GetHomePageBlockInfo(1409);
      } else {
        this.GetHomePageBlockInfo(1410);
      }

      if (!zt) {
        for (var i = 0; i < this.zxTitle.length; i++) {
          if (id == this.zxTitle[i].id) {
            this.zxTitle[i].zt = true;
            this.zxTitle.push("1");
            this.zxTitle.pop("1");
          } else {
            this.zxTitle[i].zt = false;
            this.zxTitle.push("1");
            this.zxTitle.pop("1");
          }
        }
      }
    },

    aaaa(i) {},
    dian2(zt, id) {
      this.num2 = id;
      if (id == 2) {
        this.GetHomePageBlockInfo(1404);
      } else if (id == 3) {
        this.GetHomePageBlockInfo(1384);
      } else if (id == 4) {
        this.GetHomePageBlockInfo(3742);
      }
      if (!zt) {
        for (var i = 0; i < this.hyTitle.length; i++) {
          if (id == this.hyTitle[i].id) {
            this.hyTitle[i].zt = true;
            this.hyTitle.push("1");
            this.hyTitle.pop("1");
          } else {
            this.hyTitle[i].zt = false;
            this.hyTitle.push("1");
            this.hyTitle.pop("1");
          }
        }
      }
    },

    dian3(zt, id) {
      this.num3 = id;

      if (id == 1) {
        this.GetHomePageBlockInfo(2317);
      } else if (id == 2) {
        this.GetHomePageBlockInfo(2318);
      } else if (id == 3) {
        this.GetHomePageBlockInfo(1872);
      } else {
        this.GetHomePageBlockInfo(2320);
      }

      if (!zt) {
        for (var i = 0; i < this.xsqTitle.length; i++) {
          if (id == this.xsqTitle[i].id) {
            this.xsqTitle[i].zt = true;
            this.xsqTitle.push("1");
            this.xsqTitle.pop("1");
          } else {
            this.xsqTitle[i].zt = false;
            this.xsqTitle.push("1");
            this.xsqTitle.pop("1");
          }
        }
      }
    },

    dian4(zt, id) {
      this.num4 = id;

      if (id == 2) {
        this.GetHomePageBlockInfo(3323);
      } else if (id == 3) {
        this.GetHomePageBlockInfo(2311);
      }

      if (!zt) {
        for (var i = 0; i < this.hzTitle.length; i++) {
          if (id == this.hzTitle[i].id) {
            this.hzTitle[i].zt = true;
            this.hzTitle.push("1");
            this.hzTitle.pop("1");
          } else {
            this.hzTitle[i].zt = false;
            this.hzTitle.push("1");
            this.hzTitle.pop("1");
          }
        }
      }
    },

    addtop(num, id) {
      if (num == 1) {
        for (var i = 0; i < this.zazhiData.length; i++) {
          if (id == this.zazhiData[i].id) {
            this.zazhiData[i].zt = true;
            this.zazhiData.push("1");
            this.zazhiData.pop("1");
          }
        }
      } else {
        for (var i = 0; i < this.zazhiData.length; i++) {
          this.zazhiData[i].zt = false;
          this.zazhiData.push("1");
          this.zazhiData.pop("1");
        }
      }
    },
    addtop2(num, id) {
      if (num == 1) {
        for (var i = 0; i < this.zxData.length; i++) {
          if (id == this.zxData[i].contentId) {
            this.zxData[i].zt = true;
            this.zxData.push("1");
            this.zxData.pop("1");
          }
        }
      } else {
        for (var i = 0; i < this.zxData.length; i++) {
          this.zxData[i].zt = false;
          this.zxData.push("1");
          this.zxData.pop("1");
        }
      }
    },

    addtop6(num, id) {
      if (num == 1) {
        for (var i = 0; i < this.xwData.length; i++) {
          if (id == this.xwData[i].contentId) {
            this.xwData[i].zt = true;
            this.xwData.push("1");
            this.xwData.pop("1");
          }
        }
      } else {
        for (var i = 0; i < this.xwData.length; i++) {
          this.xwData[i].zt = false;
          this.xwData.push("1");
          this.xwData.pop("1");
        }
      }
    },
    addtop3(num, id) {
      if (num == 1) {
        for (var i = 0; i < this.hyData.length; i++) {
          if (id == this.hyData[i].contentId) {
            this.hyData[i].zt = true;
            this.hyData.push("1");
            this.hyData.pop("1");
          }
        }
      } else {
        for (var i = 0; i < this.hyData.length; i++) {
          this.hyData[i].zt = false;
          this.hyData.push("1");
          this.hyData.pop("1");
        }
      }
    },
    addtop4(num, id) {
      if (num == 1) {
        for (var i = 0; i < this.xsqData.length; i++) {
          if (id == this.xsqData[i].contentId) {
            this.xsqData[i].zt = true;
            this.xsqData.push("1");
            this.xsqData.pop("1");
          }
        }
      } else {
        for (var i = 0; i < this.xsqData.length; i++) {
          this.xsqData[i].zt = false;
          this.xsqData.push("1");
          this.xsqData.pop("1");
        }
      }
    },

    addtop5(num, id) {
      if (num == 1) {
        for (var i = 0; i < this.hzData.length; i++) {
          if (id == this.hzData[i].contentId) {
            this.hzData[i].zt = true;
            this.hzData.push("1");
            this.hzData.pop("1");
          }
        }
      } else {
        for (var i = 0; i < this.hzData.length; i++) {
          this.hzData[i].zt = false;
          this.hzData.push("1");
          this.hzData.pop("1");
        }
      }
    },

    //往期
    GetGuoqiData() {
      var that = this;
      that.$httphelper
        .GetGuoqiData({
          journalId: 201607080003
        })
        .then(res => {
          if (res.code == 200) {
            that.wqData = res.data;
            that.$loading.hideLoading();
          } else {
            that.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        });
    },

    //当期快报
    GetCurrentPeriod() {
      var that = this;
      that.$httphelper
        .GetCurrentPeriod({
          journalId: 201607080003,
          year: 2021
        })
        .then(res => {
          if (res.code == 200) {
            that.zazhiData = res.data.issueInfoList || "";

            that.$loading.hideLoading();
          } else {
            that.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        });
    },

    GetHomePageBlockInfo(changId) {
      var that = this;
      that.$httphelper
        .GetHomePageBlockInfo({
          journalId: 201607080003,
          pChannelId: 0,
          channelId: changId,
          jChannelID: 0,
          dataSourceType: 1,
          dataShowType: 1,
          curr: 1,
          limit: 10
        })
        .then(res => {
          if (res.code == 200) {
            if (changId == 3876) {
              this.tzggData = res.data || [];
            }
            if (changId == 1398) {
              console.log(res.data, "qweqw");
              that.xwData = res.data || "";
            }
            if (
              changId == 2374 ||
              changId == 1406 ||
              changId == 1407 ||
              changId == 1408 ||
              changId == 1409 ||
              changId == 1410
            ) {
              that.zxData = res.data || "";
            }
            if (
              changId == 2317 ||
              changId == 2318 ||
              changId == 1872 ||
              changId == 2320
            ) {
              that.xsqData = res.data || "";
            }
            if (changId == 1404 || changId == 1384 || changId == 3742) {
              that.hyData = res.data || "";
            }
            if (changId == 2311 || changId == 3323) {
              console.log(res.data);

              that.hzData = res.data || "";
            }

            that.$loading.hideLoading();
          } else {
            that.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        });
    },

    //获取期数
    GetBackIssueBrowsing(year, issue) {
      var that = this;
      that.$httphelper
        .GetBackIssueBrowsing({
          journalId: 201607080003,
          year: Number(year),
          issue: Number(issue),
          curr: that.curr,
          limit: that.limit
        })
        .then(res => {
          if (res.code == 200) {
            that.list = res.data || "";
            that.total = res.totalcount;
          } else {
            that.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
          that.$loading.hideLoading();
        });
    },

    down(channelId, contentId, num) {
      var that = this;
      console.log(channelId, contentId);
      that.$httphelper
        .GetContentInfo({
          journalId: 201607080003,
          year: 0,
          issue: 0,
          channelId: channelId,
          contentId: contentId,
          dataSourceType: 1,
          dataShowType: 1
        })
        .then(res => {
          if (res.code == 200) {
            // window.open(res.data.siteContentInfoResult.linkUrl);

            if (
              res.data.siteContentInfoResult.linkUrl == null ||
              res.data.siteContentInfoResult.linkUrl == "" ||
              res.data.siteContentInfoResult.linkUrl == " "
            ) {
              this.$router.push({
                path: "/expert_details",
                query: { num: num, contentId: contentId, channelId: channelId }
              });
            } else {
              window.open(res.data.siteContentInfoResult.linkUrl);
            }
            that.$loading.hideLoading();
          } else {
            that.$alert("没有附件", "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        });
    }
  },
  computed: {},
  mounted() {
    // this.$ref.demo.contentWindow.location.href="http://widget.weibo.com/weiboshow/index.php?language=&width=0&height=580&fansRow=2&ptype=1&speed=0&skin=1&isTitle=1&noborder=1&isWeibo=1&isFans=0&uid=1666204871&verifier=8b63330b&dpc=1"
  },
  created() {
    this.index();
    this.GetHomePageBlockInfo(3876);
  }
};
</script>

<style lang="scss" scoped>
.author {
  width: 100%;
  min-width: 1366px;
  background-color: #f7f8fa;
  li {
    list-style-type: none;
  }
  // border:1px solid #00f;
  // height: 1000px;
  padding-top: 40px;
  overflow: hidden;

  .author_nav {
    width: 80%;
    margin: 0 auto;
    .video_title {
      width: 100%;
      height: 38px;
      border-bottom: 2px solid #dbdbdb;
      position: relative;
      margin-bottom: 30px;
      padding-bottom: 11px;
      .video_name {
        width: 100%;
        border: 1px solid #ccc;
        // border-right:1px solid #ccc;
        // border-left:1px solid #ccc;
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #000000;
        line-height: 38px;
        position: relative;
        text-align: center;
        .video_xian2 {
          width: 100%;
          height: 3px;
          background-color: var(--biao);
          position: absolute;
          left: 0;
          bottom: -13px;
        }
      }

      .video_xian {
        width: 4px;
        height: 21px;
        background: var(--xt);
        position: absolute;
        right: 0;
        top: 14px;
      }
      .video_txt {
        width: 16%;
        cursor: pointer;
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #000000;
        line-height: 38px;
        position: relative;
        text-align: center;
        float: left;
        .video_xian {
          width: 2px;
          height: 16px;
          background: #eeeeee;
          position: absolute;
          right: 0;
          top: 14px;
        }
      }
      .video_txt1 {
        width: 14%;
        cursor: pointer;
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #000000;
        line-height: 38px;
        position: relative;
        text-align: center;
        float: left;
        .video_xian {
          width: 2px;
          height: 16px;
          background: #eeeeee;
          position: absolute;
          right: 0;
          top: 14px;
        }
      }
      .video_txt2 {
        width: 10%;
        cursor: pointer;
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #000000;
        line-height: 38px;
        position: relative;
        text-align: center;
        float: left;
        .video_xian {
          width: 2px;
          height: 16px;
          background: #eeeeee;
          position: absolute;
          right: 0;
          top: 14px;
        }
      }
      .video_right {
        float: right;
        width: 90px;
        height: 12px;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #878787;
        line-height: 23px;
        cursor: pointer;
        text-align: right;
        .zi {
          font-size: 14px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #d27a13;
          line-height: 23px;
          margin-right: 9px;
          margin-top: 8px;
        }
      }
    }

    .author_left {
      overflow: hidden;
      // border:1px solid #ccc;
      float: left;
      width: 70%;
      margin-left: 15px;
      .zazhi {
        width: 100%;
        height: 100%;
        // background: #FFFFFF;
        box-shadow: 0px 2px 12px 2px rgba(219, 223, 232, 0.5);
        border-radius: 4px;
      }
      .zixun {
        box-shadow: px 2px 12px 2px rgba(219, 223, 232, 0.5);

        // border-left:1px solid #ccc ;
        .messageMain {
          li {
            list-style-type: none;
            cursor: pointer;
          }
        }
      }
      .xuesuquan {
        box-shadow: px 2px 12px 2px rgba(219, 223, 232, 0.5);

        .messageMain {
          li {
            list-style-type: none;
          }
        }
      }

      .author_nav2r {
        .wangqi {
          width: 80%;
          .wangqiMain {
            overflow: hidden;
            div {
              cursor: pointer;
              width: 100px;
              height: 30px;
              float: left;
              color: #e6454a;
              margin-left: 30px;
              margin-bottom: 20px;
              background: rgba(230, 69, 74, 0.12);
              border-radius: 8px;
              text-align: center;
              line-height: 30px;
              border: 1px solid #e6454a;
            }
          }
        }

        .authorMain {
          margin-left: 30px;
          .express_dian {
            width: 10px;
            height: 10px;
            background: #2a2d3e;
            // border-radius: 50%;
            margin-right: 6px;
            margin-left: 16px;
            float: left;
            margin-top: 6px;
            clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
            transition: 1s clip-path;
          }
          .expressMain {
            h5 {
              color: #2a2d3e;
              font-size: 18px;
            }
            div {
              margin-left: 30px;
              margin-top: -27px;
              margin-bottom: 10px;
              font-size: 18px;
              color: #657591;
            }
            span {
              display: inline;
              margin-left: 30px;
              font-size: 13px;
              color: #657591;
            }
          }
        }
      }
    }
    .author_right {
      float: right;
      width: 19%;
      margin-right: 100px;
      margin-top: 30px;
      // border:1px solid #ccc;
      // box-shadow: 0px 2px 12px 2px rgba(219, 223, 232, 0.5);
      .tup {
        margin-top: 20px;
      }
      .wenzi {
        p {
          line-height: 30px;
        }
      }
      .rightBottom {
        .lookNum {
          span {
            width: 219px;
            height: 28px;
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #2a2d3e;
            line-height: 28px;
          }
        }
      }
    }
  }
  .express_dian {
    width: 10px;
    height: 10px;
    background: #2a2d3e;
    margin-right: 6px;
    margin-left: 16px;
    float: left;
    margin-top: 6px;
    clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
    transition: 1s clip-path;
  }
}

.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}

.add2 {
  background-color: var(--xt) !important;
}
.addtxt {
  color: var(--xt) !important;
}
.hzMain {
  .imgMain {
    width: 100%;
    height: 100%;
    div {
      width: 15%;
      float: left;
      img {
        // width: 150px;
        // height: 150px;
        width: 80%;
        border: 1px dashed #dbdfe8;
        margin: 20px 0 0 20px;
        //  list-style: ;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/home/homeMain/index.vue